var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-toggle-containter",class:_vm.editMode ? 'edit-active' : 'edit-inactive',on:{"click":_vm.toggleEditMode}},[_c('div',{staticClass:"toggle-message"},[_vm._v(_vm._s(_vm.editMode ? 'stop editing' : 'engage edit'))])])}
var staticRenderFns = []

export { render, staticRenderFns }